import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
export const SvgArrowUp = (props: SvgProps) => (
  <Svg width="100%" height="100%" viewBox="0 0 50 50" {...props}>
    <Path
      d="m9 33 16-16 16 16"
      stroke={props.color}
      strokeWidth={4}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

